import React from 'react';

import { FormBuilder } from 'commons-ui';

import useClone from './useCloneBulk';
import { FORM_FIELD_CONFIG_CREATE, FORM_LAYOUT_CONFIG_CREATE, validationSchemaCreate } from '../../utils/bulkFormConfig';

const CloneBulk: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useClone();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			validationSchema={validationSchemaCreate}
			fieldConfig={FORM_FIELD_CONFIG_CREATE}
			layoutConfig={FORM_LAYOUT_CONFIG_CREATE}
		/>
	);
};

export default CloneBulk;
